import React, { useEffect } from 'react';
import UserBasicInfoContext from '../../../../components/Context/UserBasicInfoContext';
import { useContext } from 'react';
import { SUPER_ADMIN } from '../../ConstRole/ConstRole';
import Popup from '../../../../components/Popup';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
import { useState } from 'react';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import $ from 'jquery';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import { toast } from 'react-toastify';


const KamInfo = ({ companyDetails }) => {
    const profile = useContext(UserBasicInfoContext);

    const [showDialog, setShowDialog] = useState(false);

    const [userList, setUserList] = useState([]);

    useEffect(()=>{
        PostLoginGetApi("user/list/kam", "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setUserList(responseData["data"]["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);


    const handleChange = () => {
        let name = $("#user_id").find(':selected').data("name");
        let mobile_no = $("#user_id").find(':selected').data("phone");


        $("#name").html(name);
        $("#phone").html(mobile_no);
    }


    const submitForm = (event) => {
        event.preventDefault();

        let id = companyDetails?.id;
        if( id <= 0 ) {
            toast.error("Invalid company id.");
            return;
        }

        let user_id = $("#user_id").val();
        if( user_id <= 0 ) {
            toast.error("Please choose KAM");
            return;
        }

        PostLoginPostApi("update-company/" + id + "/kam", JSON.stringify({user_id: user_id}), 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    
                    let email = $("#user_id").find(':selected').data("email");
                    let name = $("#user_id").find(':selected').data("name");
                    let mobile_no = $("#user_id").find(':selected').data("phone");
                    
                    $("#current_name").html(name);
                    $("#current_email").html(email);
                    $("#current_phone").html(mobile_no);


                    setShowDialog(false);
                    toast.success("KAM assign successfully.");
                    return;
                }


                toast.error(responseData["messages"].toString());
                return;
            }

            toast.error("A problem occur. Please try again.");
        }).catch((error) => {
            console.log(error);
            toast.error("A problem occur. Please try again.");
        });
    }


    if (profile?.user_type !== SUPER_ADMIN) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <>
            {(companyDetails) &&
                <div className=" w-full pb-10 pt-0">

                    <h1 className="font-bold text-lg mb-3 px-2">KAM Info</h1>

                    <table className="custom-details-table w-full mt-0 mb-2">
                        <tbody>
                            <tr>
                                <td className="font-semibold text-base">Name</td>
                                <td className="px-5 text-base" id="current_name">{companyDetails?.user?.name}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Email Address</td>
                                <td className="px-5 text-base" id="current_email">{companyDetails?.user?.email}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Phone</td>
                                <td className="px-5 text-base" id="current_phone" >{companyDetails?.user?.mobile_no}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Action</td>
                                <td className="px-5 text-base">
                                    <button type="button" onClick={()=>setShowDialog(true)}
                                    className="text-sm px-4 py-1 text-white bg-[#00D632] border-2 border-[#00D632] rounded font-semibold hover:border-2 hover:bg-white hover:border-[#00D632] hover:text-[#00D632]">Change Kam</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>}


                {/* Process Dialog */}
                {(showDialog === true) &&
                    <div>
                        <Popup content={
                            <form onSubmit={(e)=>submitForm(e)} id="kam_form" className="p-5 font-medium">
                                <div className="flex justify-between">
                                    <h3 className="text-lg text-black font-semibold">Reassign KAM</h3>
                                    <CloseBtn className="cursor-pointer" onClick={()=>setShowDialog(false)} />
                                </div>

                                <div className='max-w-lg mt-6 pr-1 whitespace-break-spaces'>
                                <table className="custom-details-table w-full mt-0 mb-2">
                                    <tbody>
                                        <tr>
                                            <td className="font-semibold text-base">Email</td>
                                            <td className="text-base">
                                            <select name="user_id" id="user_id" onChange={handleChange} className='w-full rounded border-solid border border-dark-white' required>
                                                <option className='hidden' value="">Choose KAM</option>
                                                {userList?.map((data, index) => (
                                                    <option key={index} value={data.id} data-name={data.name} data-email={data.email}
                                                        data-phone={data.mobile_no} className='text-black'>{data.email}</option>
                                                ))}
                                            </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Name</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center' id="name">-</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Phone</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center' id="phone">-</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <button type="submit" className="mt-5 mb-2 w-full py-1.5 text-md font-semibold border-[#00D632] border-2 rounded bg-[#00D632] text-white hover:bg-white hover:text-[#00D632]">
                                    Confirm
                                </button>
                                
                                </div>

                            </form>}
                        />
                    </div>
                }
                {/* Process Dialog End */}


                <style JSX={true}>{`
                #kam_form table.custom-details-table tr td:first-child {
                    width: 140px;
                }
                `}</style>
        </>
    );
};

export default KamInfo;